import React from 'react'

const EmptyModal = ({children, modalSize, showModal,
    handleCloseModal}) => {
    
  return (
    <div className={`modal fade ${showModal ? "show d-block" : ""}`} id="modal-default">
  <div className={`modal-dialog ${modalSize}`}>
    <div className="modal-content">
      <div className="modal-header border-0 p-0 pr-2">
      <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={handleCloseModal}>
          <span aria-hidden="true">×</span>
        </button>
      </div>      
      <div className="modal-body">
       
        {children}
      </div>
      
    </div>
    {/* /.modal-content */}
  </div>
  {/* /.modal-dialog */}
</div>

  )
}

export default EmptyModal